import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { motion } from "framer-motion";
import ReactDOM from "react-dom";
import "./VCNRLocationMap.css";
import india from "../../Assets/contact/in.png";
import usa from "../../Assets/contact/us.png";
import germany from "../../Assets/contact/de.png";
import australia from "../../Assets/contact/au.png";

const offices = [
  {
    title: "India - Headquarters",
    position: { lat: 13.090963107871683, lng: 77.40816593170166 },
    details: "#135, CNR Tower, Vinayaka Nagar, B.H Road, Nelamangala, Karnataka",
    label: "Nelamangala",
    items: "33",
    eth: "4.87 ETH",
    avatar: india,
  },
  {
    title: "USA Office",
    position: { lat: 35.839144423, lng: -78.825562 },
    details: "501, Gray Marble Road, Morrisville, NC - 27560.",
    label: "Morrisville",
    items: "33",
    eth: "4.83 ETH",
    avatar: usa,
  },
  {
    title: "Germany Office",
    position: { lat: 48.6972287403165, lng: 9.671361073851585 },
    details: "Karl-Schurz-Straße 12, Göppingen 73037, Ph: +49 15209469778",
    label: "Göppingen",
    items: "33",
    eth: "4.15 ETH",
    avatar: germany,
  },
  {
    title: "Australia Office",
    position: { lat: -37.819548028632354, lng: 144.964599609375 },
    details: "Melbourne, Australia, Ph: 00 61 402 689 953",
    label: "Melbourne",
    items: "33",
    eth: "4.05 ETH",
    avatar: australia,
  },
];

const VCNRMapEmbed = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDiP7bkTtT0wDRwh9tqZoYwErHAMc_BgGM&libraries=places";
    script.async = true;
    script.onload = initMap;
    document.body.appendChild(script);

    function initMap() {
      const map = new window.google.maps.Map(
        document.getElementById("vcnr-map"),
        {
          zoom: 2,
          center: { lat: 20.5937, lng: 78.9629 },
          styles: [
            { elementType: "geometry", stylers: [{ color: "#000000" }] },
            { elementType: "labels.text.stroke", stylers: [{ color: "#000000" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#9a7dff" }] },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#9a7dff" }, { weight: 1.2 }],
            },
            {
              featureType: "landscape",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#2e004f" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#1a0033" }],
            },
          ],
        }
      );

      offices.forEach((office, index) => {
  // Instead of google.maps.Marker, use custom overlay for animated marker
  const markerDiv = document.createElement("div");
  const markerOverlay = new window.google.maps.OverlayView();

  markerOverlay.onAdd = function () {
    const layer = this.getPanes().overlayMouseTarget; // marker pane
    layer.appendChild(markerDiv);

    const root = createRoot(markerDiv);
    root.render(
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: [1, 1.3, 1], opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: "#9a7dff",
          border: "2px solid white",
          boxShadow: "0 0 12px rgba(154, 125, 255, 0.8)",
        }}
      />
    );
    markerOverlay.root = root;
  };

  markerOverlay.draw = function () {
    const projection = this.getProjection();
    const pos = projection.fromLatLngToDivPixel(
      new window.google.maps.LatLng(office.position.lat, office.position.lng)
    );
    if (pos) {
      markerDiv.style.position = "absolute";
      markerDiv.style.left = pos.x - 10 + "px"; // center marker
      markerDiv.style.top = pos.y - 10 + "px";
    }
  };

  markerOverlay.onRemove = function () {
    if (markerOverlay.root) {
      markerOverlay.root.unmount();
    }
    if (markerDiv.parentNode) {
      markerDiv.parentNode.removeChild(markerDiv);
    }
  };

  markerOverlay.setMap(map);

  // 🔹 Existing Info Card Overlay (unchanged, still animates)
  const customDiv = document.createElement("div");
  const overlay = new window.google.maps.OverlayView();

  overlay.onAdd = function () {
    const layer = this.getPanes().floatPane;
    layer.appendChild(customDiv);
    const root = createRoot(customDiv);
    root.render(
      <motion.div
        className="custom-info-box"
        initial={{ opacity: 0, scale: 0.5, y: -20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, delay: index * 0.2 }}
        whileHover={{ scale: 1.1 }}
      >
        <div className="info-card">
          <img src={office.avatar} className="info-avatar" alt={office.label} />
          <div className="info-details">
            <h4>{office.label}</h4>
            <p>{office.eth}</p>
          </div>
        </div>
      </motion.div>
    );
    overlay.root = root;
  };

  overlay.draw = function () {
    const projection = this.getProjection();
    const pos = projection.fromLatLngToDivPixel(
      new window.google.maps.LatLng(office.position.lat, office.position.lng)
    );
    if (pos) {
      customDiv.style.position = "absolute";
      customDiv.style.left = pos.x + "px";
      customDiv.style.top = pos.y + "px";
    }
  };

  overlay.onRemove = function () {
    if (overlay.root) {
      overlay.root.unmount();
    }
    if (customDiv.parentNode) {
      customDiv.parentNode.removeChild(customDiv);
    }
  };

  overlay.setMap(map);
});

    }
  }, []);

  return (
    <div>
      <h2 style={{ textAlign: "center", margin: "20px 0", color: "#9a7dff" }}>
        Our Global Offices
      </h2>
      <div id="vcnr-map" className="vcnr-map-container"></div>
    </div>
  );
};

export default VCNRMapEmbed;
